import { ReactNode, MouseEvent } from 'react';
import { clsx } from 'clsx';
import { useDocLink } from '../hooks/useDocLink';
import { LinkButton } from '../../link/LinkButton';
import { getDataIdGenerator } from '../../shared/utils/dataId';

export interface DocLinkProps {
  dataId: string;
  label?: ReactNode;
  icon?: string;
  iconOnly?: boolean;
  size?: 'sm' | 'md';
  direction?: 'left' | 'right';
  docLink: string;
  section: string;
  properties?: object;
  className?: string;
  iconClassName?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLButtonElement>) => void;
}

export function DocLink({
  dataId,
  label = 'Learn More',
  icon = 'new-window',
  iconOnly,
  direction = 'right',
  docLink,
  section,
  properties,
  iconClassName = '',
  onClick,
  ...props
}: DocLinkProps) {
  const dataIdGenerator = getDataIdGenerator(dataId);
  const { getLinkURL, trackClick } = useDocLink();

  const iconClasses = clsx([
    direction === 'right' && 'ml-1',
    direction === 'left' && 'mr-1',
    iconClassName
  ]);

  return (
    <LinkButton
      href={getLinkURL(docLink, section, properties)}
      onClick={e => {
        trackClick(docLink, section, properties);

        if (onClick) {
          onClick(e);
        }
      }}
      target='_blank'
      icon={icon}
      iconOnly={!!iconOnly}
      direction={direction}
      dataId={dataIdGenerator('doc')}
      iconClasses={iconClasses}
      {...props}
    >
      {iconOnly ? '' : label}
    </LinkButton>
  );
}
